// This constitutes of simply a wrapper component for buttons

import type React from 'react'
import { buttonStyles } from './button_styles'

type ButtonsWrapperProps = {
  children: React.ReactNode
}

export const ButtonsWrapper = (props: ButtonsWrapperProps) => {
  const classes = buttonStyles()
  const { children } = props

  return <div className={classes.buttonsWrapper}>{children}</div>
}
